<script setup lang="ts">
import type { FeedActivity } from '@/types/customer/ActivitiesFeed'
import ActivityCardBase from './ActivityCardBase.vue'

const { t, locale } = useI18n()

const props = defineProps<{
  activity: FeedActivity
  showConnector?: boolean
}>()

const getLocalizedText = (
  value: FeedActivity['title'] | FeedActivity['description'] | string | null | undefined
): string => {
  if (!value) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'object') {
    return value[locale.value as keyof typeof value] || value.en || ''
  }
  return ''
}

const description = computed(() => {
  const descText = getLocalizedText(props.activity.description)
  if (descText) return descText

  const points = props.activity.data?.points || 0
  const storeName = props.activity.data?.store_name || props.activity.data?.store || ''
  const translationKey =
    points === 0
      ? 'pages.customer.customerDetailPage.blocks.activity.checkinNoPoint.text'
      : 'pages.customer.customerDetailPage.blocks.activity.checkin.text'

  return t(translationKey, { points, store: storeName })
})

const title = computed(() => {
  return getLocalizedText(props.activity.title) || ''
})

const iconColor = computed(() => {
  return 'bg-yellow-400'
})
</script>

<template>
  <ActivityCardBase
    :icon="activity.icon || 'HeroMapPinIconSolid'"
    :icon-color="iconColor"
    :occurred-at="activity.occurred_at"
    :show-connector="showConnector"
  >
    <template #title>
      <p class="text-sm font-medium text-foreground">{{ title }}</p>
    </template>
    <template #description>
      <p class="mt-1 text-sm text-muted-foreground">{{ description }}</p>
    </template>
  </ActivityCardBase>
</template>
